import { Field, ErrorMessage } from 'formik';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';

interface Option {
	value: string | number;
	label: string;
}

interface Props {
	name: string;
	label?: string;
	options: Option[];
	placeholder?: string;
	className?: string;
	disabled?: boolean;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FormikSelect: React.FC<Props> = ({
	name,
	label,
	options = [],
	placeholder = 'Seleccione una opción',
	className = '',
	disabled = false,
	onChange,
}) => {
	return (
		<FormGroup className="mb-3">
			{label && (
				<Label
					for={name}
					style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}
				>
					{label}
				</Label>
			)}

			<Field name={name}>
				{({ field, meta, form }: { field: any; meta: any; form: any }) => (
					<>
						<Input
							type="select"
							{...field}
							id={name}
							disabled={disabled}
							className={`form-control ${className} ${
								meta.touched && meta.error ? 'is-invalid' : ''
							}`}
							onChange={(e) => {
								form.setFieldValue(name, e.target.value);
								if (onChange) onChange(e);
							}}
						>
							<option value="">{placeholder}</option>
							{Array.isArray(options) &&
								options?.map((option) => (
									<option key={option.value} value={option.value}>
										{option.label}
									</option>
								))}
						</Input>
						<FormFeedback>
							<ErrorMessage name={name} />
						</FormFeedback>
					</>
				)}
			</Field>
		</FormGroup>
	);
};
